<pr-form
  (onSubmit)="submit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
  noSubmitBtn="true"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="prFormService.close()"
    ></pr-icon>
  </button>

  <div>
    <h3 class="drawer-title">Biens immobiliers</h3>
    <ul>
      <li class="pointer choose-button" (click)="selectType('personalUse')">
        Résidence / Bien de jouissance
      </li>
      <li class="pointer choose-button" (click)="selectType('unfurnished')">
        Location nue
      </li>
      <li class="pointer choose-button" (click)="selectType('lmplmnp')">
        Location meublée
      </li>
      <li class="pointer choose-button" (click)="selectType('scpi')">SCPI</li>
    </ul>
  </div>
</pr-form>
